// src/utils/fileTypeChecker.js
export const fileTypeChecker = (types) => {
	const fileTypesObj = {};
	for (const type of types) {
		switch (type) {
			case "dwg":
				fileTypesObj["image/vnd.dwg"] = [".dwg"];
				break;
			case "jpg":
				fileTypesObj["image/jpeg"] = [".jpg", ".jpeg"];
				break;
			case "png":
				fileTypesObj["image/png"] = [".png"];
				break;
			case "gif":
				fileTypesObj["image/gif"] = [".gif"];
				break;
			case "svg":
				fileTypesObj["image/svg+xml"] = [".svg"];
				break;
			case "pdf":
				fileTypesObj["application/pdf"] = [".pdf"];
				break;
			case "doc":
				fileTypesObj["application/msword"] = [".doc"];
				break;
			case "docx":
				fileTypesObj[
					"application/vnd.openxmlformats-officedocument.wordprocessingml.document"
				] = [".docx"];
				break;
			case "mpp":
				fileTypesObj["application/vnd.ms-project"] = [".mpp"];
			case "xls":
				fileTypesObj["application/vnd.ms-excel"] = [".xls"];
				break;
			case "xlsx":
				fileTypesObj[
					"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
				] = [".xlsx"];
				break;
			case "ppt":
				fileTypesObj["application/vnd.ms-powerpoint"] = [".ppt"];
				break;
			case "pptx":
				fileTypesObj[
					"application/vnd.openxmlformats-officedocument.presentationml.presentation"
				] = [".pptx"];
				break;
			case "zip":
				fileTypesObj["application/zip"] = [".zip"];
				break;
			default:
				// Skip unsupported file types
				break;
		}
	}
	return fileTypesObj;
};

export const regexType = /\.([a-zA-Z0-9]+)(?=\?|$)/;
